HCategoriesPositions.$inject = ['$q', '$filter', 'positionsDataService'];

function HCategoriesPositions($q, $filter, positionsDataService) {
    var self = this;
    self.allPositions = [];
    self.viewCategories = [];
    var indexOfCategoryCode = {};

    //self.categories represents the fully selected categories
    //self.positions will be added under their category (which represents partially selected categories)
    //and the partially selected category will be added to self.categories
    //if self.categories and self.positions empty arrays -> that means (All Positions) are selected
    self.$onInit = function () {
        self.loading = true;
        self.categories = self.categories || [];
        self.positions = self.positions || [];
        for (var i in self.categories) {
            var tempCategory = self.categories[i];
            tempCategory.positions = [];
            tempCategory.tooltip = '';
            indexOfCategoryCode[tempCategory.code] = parseInt(i);
        }

        positionsDataService.getPositionsMapped(true)
            .then(function (resObj) {
                distributePositions(resObj.categories, resObj.positions);
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                self.loading = false;
            });
    };

    //add self.positions under their category
    //add the partially selected category (which is not added to the fully selected categories array 'self.categories')
    var distributePositions = function (categoryByCode, positionByCode) {
        var addPositionToCategory = function (category, position, tooltip) {
            category.positions = category.positions || [];
            var tempIndex = category.positions.push(position) - 1;//push() returns: array (new length)
            //add first 10 positions to the tooltip
            if (tooltip && tempIndex < 10) {
                category.tooltip = category.tooltip || '';
                category.tooltip += (position.name + ', ');
            }
            return category;
        };

        for (var l in self.positions) {
            var positionCode = self.positions[l].code;
            if (!positionCode || !positionByCode[positionCode]) {
                continue;
            }

            var categoryCode = positionByCode[positionCode].category_code;
            var pos = {
                name: positionByCode[positionCode].name,
                code: positionCode,
            };
            var cat = {
                name: categoryByCode[categoryCode].name,
                code: categoryByCode[categoryCode].code,
            };
            var index = indexOfCategoryCode[categoryCode];
            if (index === undefined) {
                index = indexOfCategoryCode[categoryCode] = self.categories.push(cat) - 1;
            }
            addPositionToCategory(self.categories[index], pos, true);
        }

        //add (and [$number] more...) at the end of each category tooltip if it's containing more than 10 positions
        for (var x in self.categories) {
            var tempCategory = self.categories[x];

            if (!tempCategory.code || !categoryByCode[tempCategory.code]) {
                self.categories.splice(x, 1);
                continue;
            }

            if (!tempCategory.name) {
                tempCategory.name = categoryByCode[tempCategory.code].name;
            }

            var positionsCount = tempCategory.positions && tempCategory.positions.length;
            if (positionsCount > 10) {
                tempCategory.tooltip += $filter('translate')('and ') + (positionsCount - 10) + $filter('translate')(' more...');
            } else if (positionsCount <= 10) {
                tempCategory.tooltip = tempCategory.tooltip.slice(0, -2);
            }
        }
    };

    self.$onChanges = function () {

    };

    self.$onDestroy = function () {
        indexOfCategoryCode = {};
    };
}

angular
    .module('components')
    .component("hCategoriesPositions", {
        bindings: {
            categories: "<",
            positions: "<",
        },
        controller: HCategoriesPositions,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-categories-positions/h-categories-positions.component.html'
    });
